<!--
 * @Author: zl
 * @Date: 2022-08-15 10:56:22
 * @LastEditTime: 2022-12-28 14:35:05
 * @LastEditors: zl
 * @Description: 项目相册
-->
<template>
	<div class='project-images primary-layout'>
		<div class="primary-header">
			<div class="left-tabs">
				<!-- <el-button type="primary"
						   size="small"
						   @click="topBtnClick('upload')">上传图片</el-button>
				<el-button type="primary"
						   plain
						   size="small"
						   icon="el-icon-download"
						   @click="topBtnClick('download')">下载</el-button>
				<el-button type="danger"
						   plain
						   size="small"
						   icon="el-icon-delete"
						   @click="topBtnClick('delete')">删除</el-button> -->
			</div>
			<div class="btnGroups">
				<!-- <template v-if="activeImageNum > 0">
					<div class="fz14">已选中{{ activeImageNum }}个图片</div>
					<el-button type="primary"
							   size="small"
							   class="mr10 ml10"
							   @click="cancelClick">取消选中</el-button>
				</template> -->
				<el-input v-model="searchForm.fileName"
						  placeholder="请输入资料名称"
						  size="small"
						  style="width: 360px">
					<el-button type="primary"
							   size="small"
							   class="btn-success"
							   slot="append"
							   @click="getImageData">查询</el-button>
				</el-input>

				<!-- 弹出框搜素区域 -->
				<el-popover placement="bottom-end"
							width="415"
							trigger="click">
					<el-form ref="searchForm"
							 :model="searchForm"
							 size="small"
							 label-width="100px">
						<el-form-item label="主体类型"
									  prop="limitId">
							<el-select v-model="searchForm.limitId"
									   placeholder="请选择"
									   clearable>
								<el-option v-for="item in limitList"
										   :key="item.id"
										   :label="item.sname"
										   :value="item.id"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="标段名称"
									  prop="packageId">
							<el-select v-model="searchForm.packageId"
									   placeholder="请选择"
									   clearable>
								<el-option v-for="item in taskList"
										   :key="item.id"
										   :label="item.sname"
										   :value="item.id"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="上传单位"
									  prop="shortName">
							<el-input v-model="searchForm.shortName"
									  placeholder="请输入"
									  clearable></el-input>
						</el-form-item>
						<el-form-item label="上传人"
									  prop="userName">
							<el-input v-model="searchForm.userName"
									  placeholder="请输入"
									  clearable></el-input>
						</el-form-item>
						<el-form-item label-width="0"
									  class="text-center borderTop">
							<el-button type="primary"
									   icon="el-icon-search"
									   @click="submitForm">查询</el-button>
							<el-button icon="el-icon-refresh"
									   @click="resetForm">重置</el-button>
						</el-form-item>
					</el-form>
					<el-button type="success"
							   size="small"
							   slot="reference"
							   icon="el-icon-arrow-down"
							   class="ml10 mr10 btn-success"></el-button>
				</el-popover>
			</div>
		</div>
		<div class="primary-content">
			<div class="left"
				 @wheel="wheel"
				 @mouseleave="handleMouseleave"
				 @mouseover="handleMouseover">
				<div class="my-slider">
					<div class="my-slider__tooltip"
						 :style="style">
						{{ formatTooltip(value) }}
					</div>
				</div>
				<el-slider ref="slider"
						   v-model="value"
						   vertical
						   :step="this.step"
						   :height="height"
						   :marks="marks"
						   :max="max"
						   :show-tooltip="false"
						   @change="sliderChange">
				</el-slider>
			</div>
			<div class="middle"
				 v-loading="contentLoading">
				<div v-for="item in allImageList"
					 :key="item.time">
					<div class="header">
						<el-checkbox v-model="item.checked"
									 @change="checkBoxChange($event, item)">{{ item.time }}</el-checkbox>
						<el-button size="mini"
								   class="ml10"
								   icon=""
								   @click="item.show = !item.show">
							{{ item.show ? '收起' : '展开' }}
							<i :class="item.show ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
						</el-button>
					</div>
					<div class="content"
						 v-show="item.show">
						<el-popover placement="bottom"
									width="75"
									trigger="hover"
									class="ml10"
									popper-class="images-popover"
									v-for="i in item.list"
									:key="i.id"
									:open-delay="1000">
							<div class="text-center custom-style">
								<el-button type="text"
										   @click="handleClick('preview', i)">预览
								</el-button>
								<el-button type="text"
										   @click="handleClick('download', i)">下载
								</el-button>
								<!-- <el-button type="text"
										   :disabled="i.createUserid != userInfo.id || i.assortment != 'picture'"
										   @click="handleClick('delete', i)">删除
								</el-button> -->
							</div>
							<span slot="reference"
								  class="hoverBox">
								<span class="activeIcon"
									  v-if="i.active">
									<i class="el-icon-check"></i>
								</span>
								<img :class="{ activeImg: i.active }"
									 :src="uploadUrl + i.fileDirectory + i.fileName + '?width=160&height=160'"
									 alt=""
									 @click="clickImg(i, item)">
							</span>
						</el-popover>
					</div>
				</div>
			</div>
			<div class="right"
				 v-loading="detailLoading">
				<template v-if="activeImageNum === 0"></template>
				<template v-else>
					<el-descriptions title="图片详情"
									 :column="1"
									 :colon="false"
									 class="custom-descriptions-images">
						<el-descriptions-item label="资料名称：">
							{{ detailObj.fileName }}
						</el-descriptions-item>
						<el-descriptions-item label="所属资料清单：">
							{{ detailObj.directory }}
						</el-descriptions-item>
						<el-descriptions-item label="关联项目：">
							{{ detailObj.projectName }}
						</el-descriptions-item>
						<el-descriptions-item label="关联标段：">
							{{ detailObj.packName }}
						</el-descriptions-item>
						<el-descriptions-item label="关联任务："
											  v-if="detailObj.task">
							{{ detailObj.task }}
						</el-descriptions-item>
						<el-descriptions-item label="文件编制单位：">
							{{ detailObj.redactUnit }}
						</el-descriptions-item>
						<el-descriptions-item label="上传人：">
							{{ detailObj.userName }}
						</el-descriptions-item>
						<el-descriptions-item label="上传单位：">
							{{ detailObj.shortName }}
						</el-descriptions-item>
						<el-descriptions-item label="上传时间：">
							{{ detailObj.createDate }}
						</el-descriptions-item>
					</el-descriptions>
				</template>
				<!-- <template v-else>
					<p class="font-bold">共选中{{ activeImageNum }}个图片</p>
					<div class="text-center mt20">
						<img :src="require('@/assets/images/moreImg.png')"
							 alt="">
					</div>
				</template> -->
			</div>
		</div>

		<!-- 上传图片 -->
		<el-dialog center
				   :close-on-click-modal="false"
				   title="添加资料"
				   :visible.sync="uploadObj.show"
				   width="1250px"
				   :before-close="uploadClose"
				   :destory-on-close="true">
			<p class="mb10">请将需要上传的文件在此窗口一次性操作完毕，窗口关闭后之前上传的文件将会被覆盖</p>
			<span style="color: red">*</span> 关联任务
			<el-select v-model="uploadObj.taskId"
					   placeholder="请选择"
					   size="small"
					   class="ml10"
					   clearable
					   @change="taskChange">
				<el-option v-for="item in relateData"
						   :key="item.id"
						   :label="item.packName + '（'+ item.auditTypeName +'）'"
						   :value="item.id"></el-option>
			</el-select>
			<myUpload v-if="uploadObj.show"
					  list-type="table"
					  ref="fileUpload"
					  :createUser="userInfo.sname"
					  :createCompany="uploadObj.upUnit"
					  :shortName="uploadObj.shortName"
					  tableName="project_album"
					  assortment="picture"
					  :aid="uploadObj.taskId"
					  :uploadType="2"
					  :acceptType="['PNG','JPG','JPEG']"></myUpload>
			<div slot="footer">
				<el-button class="btn"
						   size="small"
						   @click="uploadClick('cancel')">取 消</el-button>
				<el-button class="btn btn-blue"
						   type="primary"
						   size="small"
						   :loading="uploadObj.loading"
						   @click="uploadClick('submit')">确 定</el-button>
			</div>
		</el-dialog>

		<div class="summary-dlg"
			 :class="{ resetHeight: diaWidth == '500px' }">
			<!-- 单个预览 -->
			<el-dialog title="预览"
					   :visible.sync="previewObj.show"
					   :width="previewObj.width"
					   center
					   v-dialogDrag
					   :modal="false"
					   :close-on-click-modal="false"
					   :before-close="previewClose"
					   custom-class="summary-dlg">
				<div class="preview-box-projectData">
					<img :src="previewObj.url"
						 alt="">
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
import VUE_CONFIG from '../../../vue.config.js'
import * as API from '@/api/projectMap/projectMapIndex'
import { deleteFile } from '@/api/upload/upload'
import { selectTenantInformation } from '@/api/projectManage/ProjectIndex.js'
import { mapState } from 'vuex'
import { previewUrl,debounce } from '../../utils/tools'
export default {
	props: {
		projectId: {
			type: String,
			default: '',
		},
		diaWidth: {
			type: String,
			default: '800px',
		},
	},
	components: {},
	data() {
		return {
			searchForm: {
				projectId: '', //项目id
				createTime: '', //创建时间
				limitId: '', //主体id
				userName: '', //创建人
				fileName: '', //文件名
				shortName: '', //创建单位
				packageId: '', //标段id
			},
			value: 0, //时光轴当前激活数
			Ovalue: 0,
			activeImageNum: 0, // 当前选中的图片数
			height: '', // 时光轴高度
			allImageList: [], //所有的图片合集
			detailObj: {}, //右侧图片详情对象
			detailLoading: false,
			taskList: [], // 标段合集
			relateData: [], // 关联任务合集
			limitList: [], //主体合集
			uploadObj: {
				show: false,
				taskId: '',
				upUnit: '',
				shortName: '',
				loading: false,
			},
			marks: {}, // el-slider marks配置
			tooltipShow: false,
			step: 0, // 刻度
			max: 0, //最大值
			contentLoading: false,
			previewObj: {
				url: '',
				show: false,
			},
		}
	},
	created() {
		this.$nextTick(() => {
			this.height =
				document.querySelector('.project-images').offsetHeight -
				120 +
				'px'
		})
		this.searchForm.createTime = this.$utils.toDateString(
			new Date(),
			'yyyy-MM'
		)
		// 获取相册
		this.getImageData(true)
		// 获取关联任务
		this.getSectionList()
		// 获取当前登录人公司信息
		this.getCompanyMsg()
		// 获取标段
		this.getPackageList()
		// 获取主体
		this.getLimitList()
		this.previewObj.width = this.diaWidth
	},
	methods: {
		/**
		 * @description: 准备工作
		 */

		// 获取相册
		getImageData(first) {
			let params = this.$utils.clone(this.searchForm, true)
			params.projectId = this.projectId
			this.contentLoading = true
			this.detailObj = {}
			this.activeImageNum = 0
			API.selectProjectPicture(params)
				.then((res) => {
					let countdown = res.data.length
					setTimeout(
						() => {
							this.contentLoading = false
						},
						countdown > 0 ? 200 : 0
					)
					this.allImageList = res.data
					if (res.data.length > 0) {
						this.allImageList.forEach((x) => {
							this.$set(x, 'show', true)
							this.$set(x, 'checked', false)
						})
					}
					if (!first) {
						return
					}
					// 获取当前相册来规定展示时间轴
					let endDate = ''
					let startDate = ''
					// 获取当前相册来规定展示时间轴
					if (countdown === 0) {
						// 为0没有数据
						endDate = new Date().getFullYear() + 1
						startDate = new Date().getFullYear()
					} else if (countdown == 1) {
						// 结束时间
						endDate = this.allImageList[0].time.substring(0, 4)
						// 只有一条数据 开始时间和结束时间一致 给束时间加 1
						startDate = endDate
						endDate = parseInt(endDate) + 1 + ''
					} else {
						// 结束时间
						endDate = this.allImageList[0].time.substring(0, 4)
						// 多条数据 取最后的值
						startDate = this.allImageList[
							countdown - 1
						].time.substring(0, 4)
						// 如果开始时间和结束时间一致 结束时间加 1
						if (startDate == endDate) {
							endDate = parseInt(endDate) + 1 + ''
						}
					}
					// 开始 和 结束 时间相差年份
					let year = this.$utils.subtract(
						parseInt(endDate),
						parseInt(startDate)
					)
					// 相差月份
					let month = year * 12
					// 总值 移以月份 等于 刻度
					let num = Math.floor(this.$utils.divide(100, month))
					this.step = num
					// 循环给 marks 添加信息
					for (let i = 0; i <= 100; i++) {
						// 只有能整除刻度的值添加到 marks 里
						if (i % num == 0) {
							this.$set(this.marks, i, '')
						}
						// 计算 max
						if (i == 100) {
							if (100 % num !== 0) {
								this.value = 100 - Math.floor(100 % num)
								this.max = 100 - Math.floor(100 % num)
							} else {
								this.value = 100
								this.max = 100
							}
						}
					}

					// 计算当前value
					let nowTime = new Date()
					let nowYear = nowTime.getFullYear()
					let nowMonth = nowTime.getMonth()
					// 给marks修改开始和结束时间的label
					this.marks[0] = startDate + '年'
					this.marks[this.value] = endDate + '年'
					if (year == 1) {
						// 当前的value 为 刻度值 乘以 月份
						this.value = num * nowMonth
					} else {
						// 今年和开始年份相差年份
						let diffYearNow =
							parseInt(nowYear) - parseInt(startDate)
						// 结束和开始年份相差年份
						let diffYearTotal =
							parseInt(endDate) - parseInt(startDate)
						// 年份乘以 12 个月 再乘以刻度 等于一年的总的刻度
						let yearStep = 12 * num
						let total = diffYearNow * yearStep
						this.value = num * nowMonth + total
						// 复制开始年份 添加年份信息
						let computedDate = parseInt(
							this.$utils.clone(startDate, true)
						)
						Object.keys(this.marks).map((x) => {
							if (parseInt(x) !== 0) {
								for (let i = 1; i < diffYearTotal; i++) {
									if (parseInt(x) / yearStep == i) {
										computedDate += 1
										this.marks[x] = computedDate + '年'
									}
								}
							}
						})
					}
				})
				.catch(() => {
					this.contentLoading = false
				})
		},

		// 获取当个照片信息
		getImageInfo(data) {
			let params = {
				fileId: data.fileId,
				createUserid: data.createUserid,
				busId: data.busId,
				projectId: data.projectId,
			}
			this.detailLoading = true
			API.selectProjectPictureDetail(params)
				.then((res) => {
					this.detailObj = data
					this.detailObj = Object.assign(this.detailObj, res.data)
					this.detailLoading = false
				})
				.catch(() => {
					this.detailLoading = false
				})
		},

		// 获取标段
		getPackageList() {
			API.getSectionInfo({
				projectId: this.projectId,
				tenantId: this.$getSessionItem('tenantId'),
			}).then((res) => {
				this.taskList = res.data
			})
		},

		// 获取关联任务
		getSectionList() {
			API.getUnitList({
				projectId: this.projectId,
				size: 10000,
				current: 1,
			}).then((res) => {
				this.relateData = res.data.records
			})
		},

		// 获取当前登录人公司信息
		getCompanyMsg() {
			selectTenantInformation({
				tenantId: this.$getSessionItem('tenantId'),
			}).then((res) => {
				this.uploadObj.upUnit = res.data.unitName
				this.uploadObj.shortName = res.data.shortName
			})
		},

		// 获取主体
		getLimitList() {
			API.getLimit().then((res) => {
				this.limitList = res.data
			})
		},

		// 删除图片
		deleteFile(data, show) {
			deleteFile({ id: data.id })
				.then((res) => {
					if (show) {
						this.$message.success('删除成功！')
						this.getImageData()
					}
				})
				.catch(() => {})
		},

		// 计算年月
		computedDate(date) {
			if (this.marks[0]) {
				// 开始时间和结束时间 以及相差年份
				let startDate = this.$utils.clone(this.marks[0], true)
				let endDate = this.$utils.clone(this.marks[this.max], true)
				startDate = startDate.substring(0, 4)
				endDate = endDate.substring(0, 4)
				let year = this.$utils.subtract(
					parseInt(endDate),
					parseInt(startDate)
				)

				let obj = {}
				let total = 0
				// 获取相差年份对象
				for (let i = parseInt(startDate); i <= parseInt(endDate); i++) {
					this.$set(obj, total, i)
					total += 1
				}
				let month = year * 12
				let num = Math.floor(this.$utils.divide(100, month))
				// 值 * 12 等于一年份的值
				let currentYear = Math.floor(date / (num * 12))
				let currentMonth = null
				// 获取第一年的截止的刻度值
				let firstMonth = num * 12 - num
				if (date <= firstMonth) {
					// 当前值除以刻度值加上1得到月份
					currentMonth = date / num + 1
				} else {
					// 超过第一年的
					currentMonth = date / num
					// 等于12的时候为第二年1月
					// 其余的是除以12 取余加1 得到月份
					if (currentMonth == 12) {
						currentMonth = 1
					} else {
						currentMonth = (currentMonth % 12) + 1
					}
				}
				currentMonth =
					currentMonth < 10 ? '0' + currentMonth : currentMonth
				let result = {
					year: obj[currentYear]
						? obj[currentYear]
						: parseInt(endDate) + 1,
					month: currentMonth,
				}
				return result
			}
		},

		/**
		 * @description: 顶部按钮及搜索区域
		 */
		// 顶部按钮
		async topBtnClick(type) {
			if (type == 'upload') {
				this.uploadObj.show = true
				return
			}
			let list = this.$utils.filterTree(
				this.allImageList,
				(item) => {
					return item.active
				},
				{ children: 'list' }
			)
			if (list.length === 0) {
				this.$message.warning('至少勾选一张照片！')
				return
			}
			let state = null
			if (type == 'delete') {
				state = await this.$deleteConfirm(
					'仅可删除在项目相册处自己上传的图片，是否确定删除？',
					true
				)
				let noDeleteList = list.filter((x) => x.assortment != 'picture')
				if (noDeleteList.length > 0) {
					noDeleteList.forEach((x) => {
						let time = 0
						setTimeout(() => {
							this.$message.warning(
								`${x.fileName} 非项目相册处上传的图片不能删除！`
							)
							time += 100
						}, time)
					})
					return
				}
			}
			if (!state && state !== null) {
				return
			}
			list.map((x, index) => {
				if (type == 'download') {
					this.handleClick(type, x)
				} else {
					let status = index == list.length - 1 ? true : false

					this.deleteFile(x, status)
				}
			})
		},

		// 查询表单
		submitForm() {
			this.getImageData()
		},

		// 重置表单
		resetForm() {
			this.$refs.searchForm.resetFields()
			this.searchForm.fileName = ''
			this.getImageData()
		},

		// 取消选中
		cancelClick() {
			this.$utils.eachTree(
				this.allImageList,
				(item) => {
					if (item.id) {
						item.active = false
					} else {
						item.checked = false
					}
				},
				{ children: 'list' }
			)
			this.activeImageNum = 0
		},

		// 计算选中人数
		sumSelectNum() {
			this.activeImageNum = 0
			this.$utils.eachTree(
				this.allImageList,
				(item) => {
					if (item.id) {
						if (item.active) {
							this.activeImageNum += 1
						}
					}
				},
				{ children: 'list' }
			)
		},

		/**
		 * @description: 相片区域点击
		 */

		// 点击预览、下载
		handleClick(type, data) {
			let uploadUrl = ''
			// 本地环境代理后无法直接获取路径
			if (process.env.VUE_APP_UPLOAD_URL == '/uploadApi') {
				uploadUrl = VUE_CONFIG.devServer.proxy['/uploadApi'].target
			} else {
				uploadUrl = process.env.VUE_APP_UPLOAD_URL
			}

			if (type === 'preview') {
				if (parseInt(this.fileSize) / 1024 / 1024 > 10) {
					this.$message.warning('该附件过大，请下载后预览。')
					return
				}
				window.open(
					this.$previewUrl + previewUrl(uploadUrl + data.fileDirectory + data.fileName),
					'_blank'
				)
			} else if (type === 'delete') {
				this.deleteFile(data, true)
			} else {
				window.open(
					uploadUrl + data.fileDirectory + data.fileName,
					'_blank'
				)
			}
		},

		// 全选
		checkBoxChange(status, data) {
			data.list.forEach((x) => {
				this.$set(x, 'active', status)
			})
			this.sumSelectNum()
			this.onlyOneImg(false, data)
		},

		// 单个点击
		clickImg(data, item) {
			let status = data.active ? false : true
			this.$set(data, 'active', status)
			let list = item.list.filter((x) => x.active)
			item.checked = list.length == item.list.length ? true : false
			this.sumSelectNum()
			if (status) {
				// 选中时 给选中图片加一个选中时间
				let nowDate = this.$utils.toDateString(
					new Date(),
					'yyyy-MM-dd HH:mm:ss'
				)
				this.$set(data, 'selectTime', nowDate)
				// 如果弹窗是打开的，那么不用继续打开
				if (!this.previewObj.show) {
					this.previewObj.show = true
				}
				// 拼凑展示的图片路径
				this.previewObj.url =
					this.uploadUrl + data.fileDirectory + data.fileName
				// 获取图片详细信息
				this.onlyOneImg(status, data)
			} else {
				// 如果是取消选中，那么先将取消项的选中时间置为null
				this.$set(data, 'selectTime', null)
				// 然后获取selectTime有值的数据
				let list = this.$utils.filterTree(
					this.allImageList,
					(item) => {
						if (item.selectTime) {
							return item
						}
					},
					{ children: 'list' }
				)
				// 将获取到的数据降序排列
				let orderList = this.$utils.orderBy(list, [
					['selectTime', 'desc'],
				])
				// 数据大于0是，下标为0 的就是最新被选中的
				// 数据为空直接关闭弹窗
				if (orderList.length > 0) {
					this.previewObj.url =
						this.uploadUrl +
						orderList[0].fileDirectory +
						orderList[0].fileName
					this.onlyOneImg(true, orderList[0])
				} else {
					this.previewClose()
				}
			}
		},

		// 只有一个图片选中时触发
		onlyOneImg(status, data) {
			let list1 = this.$utils.filterTree(
				this.allImageList,
				(item) => {
					return item.active
				},
				{ children: 'list' }
			)
			// if (status) {
			this.detailObj = {}
			let params = status ? data : list1[0]
			this.getImageInfo(params)
			// }
		},

		// 格式化时间轴
		formatTooltip(value) {
			let result = this.computedDate(value)
			if (result) {
				return result.year + '年' + result.month + '月'
			}
		},

		// 滑动change
		sliderChange(value) {
			let result = this.computedDate(value)
			if (result) {
				this.searchForm.createTime = result.year + '-' + result.month
				this.getImageData()
			}
		},

		// 鼠标移入
		handleMouseover(e) {
			// this.tooltipShow = true
		},

		// 鼠标移出
		handleMouseleave(e) {
			// console.log(e, 'leave')
		},

		// 滚轮事件
		wheel(e) {
			if (e.wheelDelta > 0 || e.detail < 0) {
				if (this.value <= 100) {
					this.value += this.step
				}
			}
			if (e.wheelDelta < 0 || e.detail > 0) {
				if (this.value >= 0) {
					this.value -= this.step
				}
			}
			let result = this.computedDate(this.value)
			this.searchForm.createTime = result.year + '-' + result.month
			this.previewClose()
			this.handlerReset()
		},

		// 防抖发送
		handlerReset: debounce(function (data) {
			this.getImageData()
		}, 500),

		/**
		 * @description: 弹窗先关
		 */

		// 关联任务change
		taskChange(data) {
			this.uploadObj.taskId = data
		},

		// 上传按钮
		uploadClick(type) {
			if (type == 'cancel') {
				this.uploadClose()
				return
			}
			if (this.uploadObj.taskId === '') {
				this.$message.warning('请选择关联任务！')
				return
			}
			this.uploadObj.loading = true
			this.$refs.fileUpload.fileSend(
				this.uploadObj.taskId,
				this.projectId,
				() => {
					this.uploadObj.loading = false
					// 上传弹窗关闭
					this.uploadClose()
				},
				() => {
					this.uploadObj.show = false
					this.uploadObj.loading = false
				}
			)
		},

		// 上传弹窗关闭
		uploadClose() {
			this.uploadObj.show = false
			this.uploadObj.taskId = ''
			this.getImageData()
		},

		// 预览弹窗关闭
		previewClose() {
			this.previewObj.show = false
			this.previewObj.url = ''
		},
	},
	computed: {
		...mapState('app', {
			clientSize: (state) => state.clientSize,
		}),
		...mapState('user', {
			userInfo: (state) => state.userInfo,
		}),

		uploadUrl() {
			return this.$uploadUrl
		},

		style() {
			if (this.marks[0]) {
				// 开始时间和结束时间 以及相差年份
				let startDate = this.$utils.clone(this.marks[0], true)
				let endDate = this.$utils.clone(this.marks[this.max], true)
				startDate = startDate.substring(0, 4)
				endDate = endDate.substring(0, 4)
				let year = this.$utils.subtract(
					parseInt(endDate),
					parseInt(startDate)
				)
				let month = year * 12
				let currentMonth = this.computedDate(this.value)
				// 相差年份
				let diffYear = parseInt(currentMonth.year) - parseInt(startDate)
				let step = 0
				let bottom = 0
				if (year == 1) {
					step = this.$utils.divide(100, month).toFixed(4)
					bottom = (parseInt(currentMonth.month) - 1) * step
					if (
						endDate == currentMonth.year &&
						currentMonth.month == '01'
					) {
						bottom = 100
					}
				} else {
					step = Math.floor(this.$utils.divide(100, month + 1))
					let differ = diffYear * 12 * step
					bottom = (parseInt(currentMonth.month) - 1) * step + differ
				}
				return {
					bottom: `${bottom}%`,
				}
			}
			return ''
		},
	},
	watch: {
		'clientSize.height': {
			handler(nv, ov) {
				this.height =
					document.querySelector('.project-images').offsetHeight -
					120 +
					'px'
			},
			deep: true,
		},
	},
}
</script>

<style lang='less' scoped>
.project-images {
	padding: 20px;
	height: 100%;
	.primary-content {
		padding-top: 20px;
		display: flex;
	}
	.left {
		height: 100%;
		padding-left: 100px;
		position: relative;
		display: flex;
		min-width: 150px;
	}
	.middle {
		flex-grow: 2;
		overflow: auto;
		.header {
			font-size: 14px;
			margin-bottom: 10px;
		}
		.content {
			margin-bottom: 15px;
			display: flex;
			flex-wrap: wrap;
			img {
				border: 1px solid #eee;
				width: 160px;
				height: 160px;
			}
			img + img {
				margin-left: 20px;
			}
			.hoverBox {
				position: relative;
				.activeImg {
					border: 2px solid #0099ff !important;
				}
				.activeIcon {
					background-color: #0099ff !important;
					position: absolute;
					top: -140px;
					left: 10px;
					z-index: 99;
					border-radius: 50%;
					display: inline-block;
					width: 23px;
					height: 23px;
					line-height: 28px;
					text-align: center;
					i {
						font-size: 16px;
						font-weight: bolder;
						color: #fff !important;
					}
				}
			}
		}
	}
	.right {
		padding: 10px 15px;
		background-color: #f5f6fa;
		font-size: 14px;
		line-height: 32px;
		width: 300px;
		min-width: 300px;
		.font-bold {
			font-weight: bold;
		}
	}
	.my-slider {
		position: relative;
		height: calc(~'100% - 20px');
		.my-slider__tooltip {
			position: absolute;
			left: -100px;
			transform: translateY(50%);
			width: 100px;
			height: 25px;
			line-height: 25px;
			background-color: rgba(6, 167, 255, 0.1);
			border-radius: 3px;
			text-align: center;
			font-size: 14px;
			color: #06a7ff;
		}
	}
	::v-deep .el-slider__marks-text {
		width: 50px;
		left: -60px;
		text-align: right;
	}
	::v-deep .el-slider__bar {
		background-color: transparent;
	}

	.custom-descriptions-images {
		::v-deep .el-descriptions__header {
			margin-bottom: 10px;
		}
		::v-deep .el-descriptions__body {
			background-color: transparent;
		}
	}
	.fz14 {
		font-size: 14px;
	}
	.btn {
		padding: 0 50px;
	}
}
</style>
<style lang="less">
.images-popover {
	min-width: 75px !important;
	.custom-style {
		.el-button + .el-button {
			margin-left: 0 !important;
		}
		.el-button:hover {
			color: blue !important;
		}
		.el-button.is-disabled:hover {
			color: #c0c4cc !important;
		}
	}
}
// .summary-dlg {
// 	.el-dialog__wrapper {
// 		pointer-events: none;
// 		/deep/ .el-dialog {
// 			pointer-events: auto;
// 		}
// 		.el-dialog__body {
// 			pointer-events: auto;
// 			max-height: 600px !important;
// 		}
// 	}
// 	.el-dialog__header {
// 		pointer-events: auto !important;
// 	}
// 	.preview-box-projectData {
// 		height: 540px;
// 		img {
// 			width: 100%;
// 			height: 100%;
// 		}
// 	}
// }
// .resetHeight {
// 	.el-dialog__wrapper {
// 		.el-dialog__body {
// 			max-height: 400px !important;
// 		}
// 	}
// 	.preview-box-projectData {
// 		height: 340px;
// 	}
// }
</style>